import { FC, SVGProps } from 'react';

const ScheduleIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  color = '#2d2d2d',
  size = 24,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="17"
      viewBox="0 0 21 17"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_8297_8839)">
        <path
          d="M6.98 0.5C6.36875 0.5 5.7775 0.6025 5.22 0.8475C5.1125 0.89 5.03625 0.98875 5.0225 1.105C5.0075 1.22125 5.0575 1.335 5.1525 1.4025C5.24625 1.47125 5.37125 1.4825 5.47625 1.4325C5.9425 1.22875 6.44 1.14 6.98 1.14C9.1125 1.14 10.82 2.8475 10.82 4.98C10.82 7.1125 9.1125 8.82 6.98 8.82C4.8475 8.82 3.14 7.1125 3.14 4.98C3.14 4.0075 3.5125 3.1375 4.1 2.4475V3.28375C4.09875 3.39875 4.15875 3.50625 4.25875 3.565C4.35875 3.6225 4.48125 3.6225 4.58125 3.565C4.68125 3.50625 4.74125 3.39875 4.74 3.28375V1.46H2.91625C2.80125 1.45875 2.69375 1.51875 2.635 1.61875C2.5775 1.71875 2.5775 1.84125 2.635 1.94125C2.69375 2.04125 2.80125 2.10125 2.91625 2.1H3.55375C2.91125 2.88375 2.5 3.8775 2.5 4.98C2.5 7.45625 4.50375 9.46 6.98 9.46C9.45625 9.46 11.46 7.45625 11.46 4.98C11.46 2.50375 9.45625 0.5 6.98 0.5ZM14.66 0.5C14.31 0.5 14.02 0.79 14.02 1.14V1.78H10.97C11.1325 1.98125 11.2775 2.19625 11.4075 2.42H14.02V3.06C14.02 3.41 14.31 3.7 14.66 3.7H15.3C15.65 3.7 15.94 3.41 15.94 3.06V2.42H17.54V4.66H12.0837C12.09 4.76625 12.1 4.87125 12.1 4.98C12.1 5.08875 12.09 5.19375 12.0837 5.3H17.54V15.22H4.1V9.21C3.87125 9.05375 3.66 8.8775 3.46 8.68875V15.22C3.46 15.5913 3.72875 15.86 4.1 15.86H17.54C17.9112 15.86 18.18 15.5913 18.18 15.22V2.42C18.18 2.04875 17.9112 1.78 17.54 1.78H15.94V1.14C15.94 0.79 15.65 0.5 15.3 0.5H14.66ZM14.66 1.14H15.3V3.06H14.66V1.14ZM6.975 2.095C6.79875 2.09875 6.6575 2.24375 6.66 2.42V4.92875C6.65 4.9975 6.66125 5.0675 6.695 5.12875C6.72375 5.18625 6.77 5.23375 6.82625 5.265L8.06875 6.19625C8.21 6.3025 8.41 6.27375 8.51625 6.13125C8.6225 5.99 8.59375 5.79 8.45125 5.68375L7.3 4.82V2.42C7.30125 2.33375 7.2675 2.25 7.20625 2.18875C7.145 2.1275 7.06125 2.09375 6.975 2.095ZM11.84 6.58C11.7675 6.80125 11.6775 7.01375 11.5763 7.22H12.74V8.82H10.5V11.06H8.9V9.72375C8.69375 9.8075 8.47875 9.875 8.26 9.93125V11.06H6.66V10.0838C6.4425 10.07 6.22875 10.0463 6.02 10.0063V13.94H15.62V6.58H11.84ZM13.38 7.22H14.98V8.82H13.38V7.22ZM11.14 9.46H12.74V11.06H11.14V9.46ZM13.38 9.46H14.98V11.06H13.38V9.46ZM6.66 11.7H8.26V13.3H6.66V11.7ZM8.9 11.7H10.5V13.3H8.9V11.7ZM11.14 11.7H12.74V13.3H11.14V11.7ZM13.38 11.7H14.98V13.3H13.38V11.7Z"
          fill="#2d2d2d"
          stroke={color}
          strokeWidth="0.4"
        />
      </g>
      <defs>
        <clipPath id="clip0_8297_8839">
          <rect
            width="20"
            height="16"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ScheduleIcon;
